import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, NgZone, OnDestroy, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { OnePlaceHeaderComponent, OnePlaceHeaderModule } from '@tnr/oneplace-header';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, FormsModule, OnePlaceHeaderModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements AfterViewInit, OnDestroy {
  @ViewChild(OnePlaceHeaderComponent)
  oneplaceHeader!: OnePlaceHeaderComponent;

  private readonly router = inject(Router);
  private readonly ngZone = inject(NgZone);

  oneplaceHeaderOptions: OnePlaceHeaderComponent['data'] = {
    headerLogoOptions: {
      imageUrl: 'assets/images/logo.svg',
      altText: 'Colab Logo',
      name: environment.colab.oneplaceHeaderName
    },
    headerQuickLinkOptions: {
      config: {
        dropDownLabel: 'Quick Links',
        headerText: '',
        links: []
      }
    }
  };

  navigateToRoot(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    this.ngZone.run(() => {
      this.router.navigate(['/']);
    });
  }

  ngAfterViewInit(): void {
    // workaround: for the issue where the @tnr/oneplace-header header logo button navigate with delay
    // angular host app appears to not handling the navigate properly when the navigation triggerd from @tnr/oneplace-header

    // it stops the default click event in @tnr/oneplace-header and allows custom handling
    this.oneplaceHeader.isHeaderLoaded$.subscribe((isLoaded) => {
      const element = document.getElementById('header-home-button');
      if (isLoaded && element) {
        element.addEventListener('click', this.navigateToRoot.bind(this), true);
      }
    });
  }

  ngOnDestroy(): void {
    const element = document.getElementById('header-home-button');
    if (element) {
      element.removeEventListener('click', this.navigateToRoot.bind(this), true);
    }
  }
}
